
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/divorce/lookup/[state]",
      function () {
        return require("private-next-pages/divorce/lookup/[state]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/divorce/lookup/[state]"])
      });
    }
  